import { NextApiRequest } from 'next'
import { IncomingMessage, ServerResponse } from 'http'
import * as cookie from 'cookie'

export type RequestCookies = Partial<Record<string, string>>

const DEFAULT_COOKIE_MAX_AGE_IN_SECONDS = 60

// Check if IncomingMessage is NextApiRequest
const requestHasCookies = (req: IncomingMessage | NextApiRequest): req is NextApiRequest => {
  return (req as NextApiRequest).cookies !== undefined
}

export const parseCookieString = (cookieString?: string) => cookie.parse(cookieString ?? '')

export const getCookiesFromRequest = <R extends IncomingMessage>(req: R): RequestCookies => {
  return requestHasCookies(req) ? req.cookies : parseCookieString(req.headers.cookie)
}

export const getCookieBooleanValue = <R extends IncomingMessage>(req: R, key: string) => {
  const cookies = getCookiesFromRequest(req)
  return cookies[key] === 'true'
}

export const setCookieInResponse = <R extends ServerResponse>(
  res: R,
  cookies: string | string[]
): R => {
  return res.setHeader('Set-Cookie', cookies)
}

export const serializeCookie = (name: string, value: string, options?: cookie.SerializeOptions) =>
  cookie.serialize(name, value, {
    path: '/',
    maxAge: DEFAULT_COOKIE_MAX_AGE_IN_SECONDS,
    ...options,
  })
